import { is, createStore } from "effector";
function storify(value, config) {
  if (is.store(value)) return value;
  return createStore(value, { ...config, skipVoid: false });
}
export {
  storify
};
//# sourceMappingURL=storify.mjs.map
